import { render, staticRenderFns } from "./activity_sel_page.vue?vue&type=template&id=4da72d0e"
import script from "./activity_sel_page.vue?vue&type=script&lang=js"
export * from "./activity_sel_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4da72d0e')) {
      api.createRecord('4da72d0e', component.options)
    } else {
      api.reload('4da72d0e', component.options)
    }
    module.hot.accept("./activity_sel_page.vue?vue&type=template&id=4da72d0e", function () {
      api.rerender('4da72d0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/group_buy/components/activity_sel_page.vue"
export default component.exports